import { connect } from 'react-redux';
import HouseList from '../components/AddressBook/HouseList';
import * as actions from '../redux/actions/AddressBook';
import * as ngSendingsActions from '../redux/actions/NgSendings';
import * as selectors from '../redux/selectors/addressBookSelector';
import { push } from 'react-router-redux';
import { getUser as getUserSelector } from '../redux/selectors/accountSettingSelector';
import { getSalesforceSyncLastUpdate, getSalesforceConfig } from '../redux/actions/Salesforce';
import { getUser } from '../redux/actions/AccountSetting';
import { getLetterOrderList } from '../redux/actions/LetterOrderList';
import { getFollowCallOrderList } from '../redux/actions/FollowCallOrder';
import { postFollowCallOrdersOrder } from '../redux/actions/FollowCallOrder';
import { HouseListDirectory } from '../constants/ComponentTypes';
import { SYNC_TYPE } from '../constants/SalesforceValues';

const mapStateToProps = (state) => ({
  addressItems: selectors.getAddressItems(state),
  error: state.addressBook.error,
  errorItems: selectors.getErrorItems(state),
  errorMessage: state.addressBook.errorMessage || state.followCallOrder.errorMessage,
  isPostingFollowCallOrder: state.followCallOrder.isPostingFollowCallOrder,
  isDeleting: state.addressBook.isDeleting,
  isFiltering: state.addressBook.isFiltering,
  isLoading: state.addressBook.isLoading,
  isLoadingErrorAddress: state.addressBook.isLoadingErrorAddress,
  isLoadingWarningAddress: state.addressBook.isLoadingWarningAddress,
  isLoadingNgList: state.addressBook.isLoadingNgList,
  isPutting: state.addressBook.isPutting,
  isSaving: state.addressBook.isSaving,
  savingStatusData: state.addressBook.savingStatusData,
  isUpdatingTags: state.addressBook.isUpdatingTags,
  shortMessage: state.addressBook.shortMessage,
  successMessage: state.addressBook.successMessage,
  ngList: selectors.getNgList(state),
  tags: (() => {
    switch (state.router.location.pathname) {
      case HouseListDirectory.MAIN.path:
        return state.addressBook.tags;
      case HouseListDirectory.ERROR.path:
        return state.addressBook.errorAddressTags;
      case HouseListDirectory.WARNING.path:
        return state.addressBook.warningAddressTags;
      default:
        return state.addressBook.tags;
    }
  })(),
  importHistories: (() => {
    switch (state.router.location.pathname) {
      case HouseListDirectory.MAIN.path:
        return state.addressBook.importHistories;
      case HouseListDirectory.ERROR.path:
        return state.addressBook.errorImportHistories;
      case HouseListDirectory.WARNING.path:
        return state.addressBook.warningImportHistories;
      default:
        return state.addressBook.importHistories;
    }
  })(),
  user: getUserSelector(state),
  warningItems: selectors.getWarningItems(state),
  undoable: state.addressBook.undoable,
  prevItem: state.addressBook.prevItem,
  pageInfo_all: state.addressBook.pageInfo_all,
  pageInfo_warning: state.addressBook.pageInfo_warning,
  pageInfo_error: state.addressBook.pageInfo_error,
  pageInfo_ngList: state.addressBook.pageInfo_ngList,
  execListCount: state.addressBook.execListCount,
  type: (() => {
    switch (state.router.location.pathname) {
      case HouseListDirectory.MAIN.path:
        return HouseListDirectory.MAIN.name;
      case HouseListDirectory.ERROR.path:
        return HouseListDirectory.ERROR.name;
      case HouseListDirectory.WARNING.path:
        return HouseListDirectory.WARNING.name;
      case HouseListDirectory.NG_LIST.path:
        return HouseListDirectory.NG_LIST.name;
      default:
        return HouseListDirectory.MAIN.name;
    }
  })(),
  routerInfo: state.router.location,
  overwrite: state.addressBook.overwrite,
  corporations: selectors.getCorporations(state),
  isLoadingCorp: state.addressBook.isLoadingCorp,
  failedLinkCorporationCount: state.addressBook.failedLinkCorporationCount,
  isPostWarningAddressWithExecutivePerson: state.addressBook.isPostWarningAddressWithExecutivePerson,
  isOverwritingWarningAddress: state.addressBook.isOverwritingWarningAddress,
  totalAddresses: state.addressBook.totalAddresses,
  totalWarningAddresses: state.addressBook.totalWarningAddresses,
  totalErrorAddresses: state.addressBook.totalErrorAddresses,
  totalNgList: state.addressBook.totalNgList,
  isLoadingSidebar: state.addressBook.isLoadingSidebar,
  isDeletingAddressTags: state.addressBook.isDeletingAddressTags,
  isUpdatingAddressTags: state.addressBook.isUpdatingAddressTags,
  isLoadingSelectedAddressTags: state.addressBook.isLoadingSelectedAddressTags,
  selectedAddressTags: state.addressBook.selectedAddressTags,
  isVerifying: state.addressBook.isVerifying,
  isUpdatingDifferences: state.addressBook.isUpdatingDifferences,
  addressCorporationDifferencesCount: state.addressBook.addressCorporationDifferencesCount,
  showDemoData: state.accountSetting.showAddressDemoData,
  limitUsage: state.accountSetting.user && !state.accountSetting.user.send_letter_flag,
  isLoaded: state.accountSetting.isLoaded,
  lastUpdate: state.addressBook.lastUpdate || state.salesforce.lastUpdate, // 初回表示時と手動同期時
  isImporting: state.addressBook.isImporting,
  syncCount: state.addressBook.syncCount || state.salesforce.syncCount, // 初回表示時と手動同期時
  filterValue: state.addressBook.filterValue,
  hasLetterOrderHistoryNames: state.addressBook.hasLetterOrderHistoryNames,
  duplicateNames: state.addressBook.duplicateNames,
  orderedFollowCallNames: state.addressBook.orderedFollowCallNames,
  isLoadingCheck: state.addressBook.isLoadingCheck,
  isMixedAddresses: state.addressBook.isMixedAddresses,
  selectAddress: state.addressBook.selectAddress,
  letterOrderList: state.letterOrderList.letterOrderList,
  followCallOrderList: state.followCallOrder.followCallOrderList,
})

const mapDispatchToProps = dispatch => ({
  getAddress(data, tab, overwrite) {
    dispatch(actions.getAddress(data, tab, overwrite));
  },

  getErrorAddress(data, overwrite) {
    dispatch(actions.getErrorAddress(data, overwrite));
  },

  getWarningAddress(data, overwrite) {
    dispatch(actions.getWarningAddress(data, overwrite));
  },

  getAddressTags() {
    dispatch(actions.getAddressTags());
    dispatch(actions.getWarningAddressTags());
    dispatch(actions.getErrorAddressTags());
  },

  getSelectedAddressTags(data, overwrite) {
    dispatch(actions.getAddressTags(data, false, overwrite));
  },

  getAddressImportHistoryTags() {
    dispatch(actions.getAddressImportHistoryTags());
    dispatch(actions.getWarningAddressImportHistoryTags());
    dispatch(actions.getErrorAddressImportHistoryTags());
  },

  getUserInfo() {
    dispatch(getUser(true));
  },

  getSalesforceConfig() {
    dispatch(getSalesforceConfig());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },

  addItems(items) {
    dispatch(actions.addItems(items));
  },

  addItemsFromExcel(items) {
    dispatch(actions.addItemsFromExcel(items));
  },

  putAddressTagMulti(data) {
    dispatch(actions.putAddressTagMulti(data));
  },

  deleteAddressMulti(addressItems) {
    dispatch(actions.deleteAddressMulti(addressItems));
  },

  deleteErrorAddressMulti(data) {
    dispatch(actions.deleteErrorAddressMulti(data));
  },

  deleteWarningAddressMulti(data) {
    dispatch(actions.deleteWarningAddressMulti(data));
  },

  editAddress(item) {
    dispatch(actions.editItems(item));
  },

  postErrorAddress(item) {
    dispatch(actions.postErrorAddress(item));
  },

  postWarningAddress(item) {
    dispatch(actions.postWarningAddress(item));
  },

  postWarningAddressRestore(item) {
    dispatch(actions.postWarningAddressRestore(item));
  },

  clearAddressData() {
    dispatch(actions.clearAddressData());
  },

  deleteErrorAddressById(id) {
    dispatch(actions.deleteErrorAddressById(id));
  },

  deleteWarningAddressById(id) {
    dispatch(actions.deleteWarningAddressById(id));
  },

  getAddressSuggestCorporations(id, data) {
    dispatch(actions.getAddressSuggestCorporations(id, data));
  },

  getFailedLinkAddress() {
    dispatch(actions.getFailedLinkAddress());
  },

  putAddressLinkCorporation(data) {
    dispatch(actions.putAddressLinkCorporation(data));
  },

  postWarningAddressWithExecutivePerson(warningAddressId, isReferExecutivePerson) {
    dispatch(actions.postWarningAddressWithExecutivePerson(warningAddressId, isReferExecutivePerson));
  },

  postWarningAddressOverwrite(warningAddressId) {
    dispatch(actions.postWarningAddressOverwrite(warningAddressId));
  },

  getAddressTotals() {
    dispatch(actions.getAddressTotals());
  },

  getExecutiveList(data) {
    dispatch(actions.getExecutiveListCount(data));
  },

  getNgSendings(data, overwrite) {
    dispatch(ngSendingsActions.getNgSendings(data, overwrite));
  },

  postNgSendings(data) {
    dispatch(ngSendingsActions.postNgSendings(data));
  },

  postNgSendingsExcel(data) {
    dispatch(ngSendingsActions.postNgSendingsExcel(data));
  },

  putNgSendings(data) {
    dispatch(ngSendingsActions.putNgSendings(data));
  },

  deleteNgSendings(data) {
    dispatch(ngSendingsActions.deleteNgSendings(data));
  },

  deleteNgSendingsById(id) {
    dispatch(ngSendingsActions.deleteNgSendingsById(id));
  },

  postAddressesMoveNgSendings(data) {
    dispatch(actions.postAddressesMoveNgSendings(data));
  },

  postAddressesRestoreNgSendings(data) {
    dispatch(actions.postAddressesRestoreNgSendings(data));
  },

  getWarningAddressSuggestCorp(id, data) {
    dispatch(actions.getWarningAddressSuggestCorp(id, data));
  },

  getErrorAddressSuggestCorp(id, data) {
    dispatch(actions.getErrorAddressSuggestCorp(id, data));
  },

  putAddressesTagsDeleteMulti(data) {
    dispatch(actions.putAddressesTagsDeleteMulti(data));
  },

  putAddressesTagsUpdateTagNameMulti(data) {
    dispatch(actions.putAddressesTagsUpdateTagNameMulti(data));
  },

  putWarningAddressesTagsDeleteMulti(data) {
    dispatch(actions.putWarningAddressesTagsDeleteMulti(data));
  },

  putWarningAddressesTagsUpdateTagNameMulti(data) {
    dispatch(actions.putWarningAddressesTagsUpdateTagNameMulti(data));
  },

  putErrorAddressesTagsDeleteMulti(data) {
    dispatch(actions.putErrorAddressesTagsDeleteMulti(data));
  },

  putErrorAddressesTagsUpdateTagNameMulti(data) {
    dispatch(actions.putErrorAddressesTagsUpdateTagNameMulti(data));
  },

  postAddressCorporationDifferencesVerify(data) {
    dispatch(actions.postAddressCorporationDifferencesVerify(data));
  },

  getAddressCorporationDifferencesCount() {
    dispatch(actions.getAddressCorporationDifferencesCount());
  },

  postAddressCorporationDifferencesUpdateDifference(data) {
    dispatch(actions.postAddressCorporationDifferencesUpdateDifference(data));
  },

  postWarningAddressesOverwritemulti(data) {
    dispatch(actions.postWarningAddressesOverwritemulti(data));
  },

  postWarningAddressesMulti(data) {
    dispatch(actions.postWarningAddressesMulti(data));
  },

  getAddressesDemo(data, overwrite) {
    dispatch(actions.getAddressesDemo(data, overwrite));
  },

  getSalesforceSyncLastUpdate() {
    dispatch(getSalesforceSyncLastUpdate({"sync_type": SYNC_TYPE.IMPORT}));
  },

  postSalesforceSync() {
    dispatch(actions.postSalesforceSync());
  },

  storeFilterValue(data) {
    dispatch(actions.storeFilterValue(data));
  },

  getSendAddressesConfirm(data) {
    dispatch(actions.getSendAddressesConfirm(data));
  },

  getOrderedFollowCallConfirm(data) {
    dispatch(actions.getOrderedFollowCallConfirm(data));
  },

  postFollowCallOrdersOrder(data) {
    dispatch(postFollowCallOrdersOrder(data));
  },

  getLetterOrderList(data, overwrite) {
    dispatch(getLetterOrderList(data, overwrite));
  },

  getFollowCallOrderList(data, overwrite) {
    dispatch(getFollowCallOrderList(data, overwrite));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(HouseList);



// WEBPACK FOOTER //
// ./src/containers/HouseList.js